import useEvent from '../useEvent.js';
import useDragPosition from './useDragPosition.js';

function getMouseEventPosition(event) {
  return {
    horizontalChange: event.clientX,
    verticalChange: event.clientY
  };
}
var useMouseDrag = function useMouseDrag(target, onDrag) {
  var _useDragPosition = useDragPosition(getMouseEventPosition, onDrag),
    isDragging = _useDragPosition.isDragging,
    handleDragStart = _useDragPosition.handleDragStart,
    handleDragMove = _useDragPosition.handleDragMove,
    handleDragEnd = _useDragPosition.handleDragEnd;
  useEvent('mousedown', handleDragStart, target);
  useEvent('mousemove', isDragging ? handleDragMove : null, undefined, {
    passive: false
  });
  useEvent('mouseup', handleDragEnd);
  return isDragging;
};

export { useMouseDrag as default };
//# sourceMappingURL=useMouseDrag.js.map
